import { Tooltip } from "@/components/ui/Tooltip";
import { HelpQuestionIcon } from "@givenwell/core-solid-icons";
import { styled } from "@givenwell/stitches";

type AllowanceConversionNoteProps = {
  /** e.g. "Your wallet holds US$50.00, converted at today's rate of ~₱60.96" */
  note: string;
  /** Longer copy explaining the two currencies and that the rate moves. */
  help: string;
};

/**
 * The caption under an allowance headline that accounts for the wallet's own currency, so the two
 * currencies never have to share a line. The help affordance answers the question the caption raises:
 * why the balance is quoted in a currency the wallet isn't held in, and why the figure will drift.
 */
export function AllowanceConversionNote({ note, help }: AllowanceConversionNoteProps) {
  return (
    <Note>
      {note}{" "}
      <Tooltip content={help} side="bottom">
        <HelpButton type="button" aria-label="Why is my balance shown in two currencies?">
          <HelpQuestionIcon style={{ width: 14, height: 14 }} />
        </HelpButton>
      </Tooltip>
    </Note>
  );
}

const Note = styled("div", {
  fontScale: "sm",
  weight: 500,
  lineHeight: 1.4,
  opacity: 0.75,
  textWrap: "pretty",
});

// Inline rather than a flex sibling, so it trails the last word instead of stranding itself
// alongside a centred block when the caption wraps.
const HelpButton = styled("button", {
  display: "inline-flex",
  verticalAlign: "-2px",
  color: "inherit",
  "&:hover, &:focus-visible": { opacity: 0.7 },
});
